import { SurveyModel } from 'survey-core';

export const extractCaptchaToken = (sender: SurveyModel): string | null => {
  const captchaQuestion = sender.getQuestionByName('captcha-question');
  return captchaQuestion ? captchaQuestion.value : null;
};
